import { Auth } from 'aws-amplify';

const PHONE_ATTRIBUTE = 'phone_number';

export async function startSmsEnrollment(phoneNumber: string): Promise<void> {
  const user = await Auth.currentAuthenticatedUser();
  await Auth.updateUserAttributes(user, {
    [PHONE_ATTRIBUTE]: phoneNumber,
  });
  await Auth.verifyCurrentUserAttribute(PHONE_ATTRIBUTE);
}

export async function confirmSmsEnrollment(code: string): Promise<void> {
  const user = await Auth.currentAuthenticatedUser();
  await Auth.verifyCurrentUserAttributeSubmit(PHONE_ATTRIBUTE, code);
  await Auth.setPreferredMFA(user, 'SMS_MFA');
}

export async function disableSmsEnrollment(): Promise<void> {
  const user = await Auth.currentAuthenticatedUser();
  await Auth.setPreferredMFA(user, 'NOMFA');
}
